var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex", staticStyle: { "align-items": "center" } },
    [
      _vm.todo.type === _vm.ListItemType.Header
        ? [
            _vm.editTodoText === null
              ? _c("label", [_c("b", [_vm._v(_vm._s(_vm.todo.text))])])
              : _vm._e()
          ]
        : _vm.todo.type === _vm.ListItemType.RadioGroup
        ? [
            _vm.editable && _vm.todo.required
              ? [
                  _c("i", {
                    staticClass: "fa fa-exclamation text-danger",
                    attrs: { title: _vm.$t("todo.required") }
                  }),
                  _vm._v("\n       \n    ")
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.editTodoText === null
              ? _c("label", [_vm._v(_vm._s(_vm.todo.text))])
              : _vm._e()
          ]
        : _c(
            "div",
            {
              staticClass: "form-check d-flex",
              staticStyle: { "align-items": "center" }
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.todo.completed,
                    expression: "todo.completed"
                  }
                ],
                staticClass: "form-check-input",
                class: { "c-pointer": _vm.editable },
                attrs: {
                  type: "checkbox",
                  id: _vm._uid + "_task" + _vm.todo.id,
                  disabled: !_vm.canCheck
                },
                domProps: {
                  checked: Array.isArray(_vm.todo.completed)
                    ? _vm._i(_vm.todo.completed, null) > -1
                    : _vm.todo.completed
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.todo.completed,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.todo, "completed", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.todo,
                              "completed",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.todo, "completed", $$c)
                      }
                    },
                    function($event) {
                      _vm.$nextTick(() => _vm.notifyChange())
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _vm.editable && _vm.todo.required
                ? [
                    _c("i", {
                      staticClass: "fa fa-exclamation text-danger",
                      attrs: { title: _vm.$t("todo.required") }
                    }),
                    _vm._v("\n       \n    ")
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.editTodoText === null
                ? _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      class: { "c-pointer": _vm.editable },
                      style: {
                        "text-decoration": _vm.todo.completed
                          ? "line-through"
                          : "inherit"
                      },
                      attrs: { for: _vm._uid + "_task" + _vm.todo.id }
                    },
                    [_vm._v("\n      " + _vm._s(_vm.todo.text) + "\n    ")]
                  )
                : _vm._e()
            ],
            2
          ),
      _vm._v(" "),
      _vm.editTodoText !== null
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.editTodoText,
                expression: "editTodoText"
              }
            ],
            ref: "editBox",
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.editTodoText },
            on: {
              keyup: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.saveTodoText.apply(null, arguments)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  )
                    return null
                  $event.stopPropagation()
                  _vm.editTodoText = null
                }
              ],
              blur: function($event) {
                _vm.editTodoText = null
              },
              input: function($event) {
                if ($event.target.composing) return
                _vm.editTodoText = $event.target.value
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticStyle: { flex: "1 1 0" } }),
      _vm._v(" "),
      _vm.editTodoText === null
        ? [
            _vm.todo.type === _vm.ListItemType.RadioGroup
              ? [
                  !_vm.isEditingTypeData
                    ? _c("div", { staticClass: "mr-4" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-row align-items-center" },
                          [
                            _c(
                              "div",
                              { staticClass: "d-flex flex-column" },
                              _vm._l(_vm.radioGroupEntries, function(
                                radioGroupEntry,
                                i
                              ) {
                                return _c(
                                  "div",
                                  { staticClass: "form-check" },
                                  [
                                    _c("input", {
                                      staticClass: "form-check-input",
                                      attrs: {
                                        type: "radio",
                                        name: _vm._uid + "radiogroup",
                                        id: _vm._uid + radioGroupEntry.label
                                      },
                                      domProps: {
                                        checked: radioGroupEntry.checked
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.selectRadioGroupEntry(
                                            i,
                                            $event.target.checked
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass: "form-check-label",
                                        attrs: {
                                          for: _vm._uid + radioGroupEntry.label
                                        }
                                      },
                                      [_vm._v(_vm._s(radioGroupEntry.label))]
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            !_vm.radioGroupEntries.length
                              ? _c("span", [
                                  _vm._v(
                                    "(" +
                                      _vm._s(_vm.$t("general.noEntries")) +
                                      ")"
                                  )
                                ])
                              : _vm._e(),
                            _vm._v("\n\n           \n          "),
                            _vm.editable && _vm.editorMode
                              ? _c("i", {
                                  staticClass: "fa fa-pen c-pointer",
                                  on: { click: _vm.startEditTypedData }
                                })
                              : _vm._e()
                          ]
                        )
                      ])
                    : _c("RadioGroupEditor", {
                        ref: "radioGroupEditor",
                        staticClass: "mr-4",
                        on: { input: _vm.saveTodoTypedData },
                        model: {
                          value: _vm.editTodoTypedData,
                          callback: function($$v) {
                            _vm.editTodoTypedData = $$v
                          },
                          expression: "editTodoTypedData"
                        }
                      })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.todo.type === _vm.ListItemType.Comment
              ? [
                  !_vm.isEditingTypeData
                    ? _c("div", { staticClass: "mr-4" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t("todoComment") +
                                ": " +
                                (_vm.todo.typedData
                                  ? _vm.todo.typedData
                                  : "(" + _vm.$t("todoEmpty") + ")")
                            ) +
                            "\n        "
                        ),
                        _vm.editable
                          ? _c("i", {
                              staticClass: "fa fa-pen c-pointer",
                              on: { click: _vm.startEditTypedData }
                            })
                          : _vm._e()
                      ])
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.editTodoTypedData,
                            expression: "editTodoTypedData"
                          }
                        ],
                        ref: "typedEditBox",
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.editTodoTypedData },
                        on: {
                          keyup: [
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.saveTodoTypedData.apply(
                                null,
                                arguments
                              )
                            },
                            function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k($event.keyCode, "esc", 27, $event.key, [
                                  "Esc",
                                  "Escape"
                                ])
                              )
                                return null
                              $event.stopPropagation()
                              _vm.editTodoTypedData = null
                            }
                          ],
                          blur: function($event) {
                            _vm.editTodoTypedData = null
                          },
                          input: function($event) {
                            if ($event.target.composing) return
                            _vm.editTodoTypedData = $event.target.value
                          }
                        }
                      })
                ]
              : _vm.todo.type === _vm.ListItemType.ScanCell
              ? [
                  !_vm.isEditingTypeData
                    ? _c("div", { staticClass: "mr-4" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t("todo.scanCell.cell") +
                                ": " +
                                (_vm.todo.typedData
                                  ? _vm.getCellName(_vm.todo.typedData)
                                  : "(" + _vm.$t("todoEmpty") + ")")
                            ) +
                            "\n        "
                        ),
                        _vm.canEditScanCell
                          ? _c("i", {
                              staticClass: "fa fa-pen c-pointer",
                              on: { click: _vm.startEditTypedData }
                            })
                          : _vm._e()
                      ])
                    : [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("todo.scanCell.cell") + ": ") +
                            "\n        "
                        ),
                        _c("vSelect", {
                          ref: "typedEditBox",
                          staticStyle: { "min-width": "5em" },
                          attrs: {
                            options: _vm.cells,
                            label: "name",
                            reduce: d => d.id
                          },
                          model: {
                            value: _vm.editTodoTypedDataForIntegerVSelect,
                            callback: function($$v) {
                              _vm.editTodoTypedDataForIntegerVSelect = $$v
                            },
                            expression: "editTodoTypedDataForIntegerVSelect"
                          }
                        })
                      ]
                ]
              : _vm.todo.type === _vm.ListItemType.Signature &&
                _vm.todo.typedData
              ? [
                  _c("img", {
                    staticStyle: {
                      height: "1.875em",
                      border: "1px solid var(--secondary)"
                    },
                    attrs: { src: _vm.todo.typedData, alt: "signature" }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.editorMode && _vm.canRequired
              ? [
                  _c("div", { staticClass: "custom-control custom-switch" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.required,
                          expression: "required"
                        }
                      ],
                      staticClass: "custom-control-input",
                      attrs: {
                        type: "checkbox",
                        id: "customSwitch" + _vm._uid
                      },
                      domProps: {
                        checked: Array.isArray(_vm.required)
                          ? _vm._i(_vm.required, null) > -1
                          : _vm.required
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.required,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.required = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.required = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.required = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "custom-control-label",
                        attrs: {
                          for: "customSwitch" + _vm._uid,
                          title: _vm.$t("todo.required")
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-exclamation text-danger"
                        })
                      ]
                    )
                  ])
                ]
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "btn-group float-right ml-2",
          attrs: { role: "group", "aria-label": "Basic example" }
        },
        [
          _vm.editable
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-primary",
                  on: { click: _vm.startEditTodo }
                },
                [_c("i", { staticClass: "fa fa-pen" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.editable && _vm.deletable
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-danger",
                  on: { click: _vm.removeTodo }
                },
                [_c("i", { staticClass: "fa fa-trash" })]
              )
            : _vm._e()
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }